import { lazyNamed } from 'src/utils/lazyNamed';
import InventoryManagement from './pages/InventoryManagementSection';

export const AnalogOperations = {
  CampaignManagement: lazyNamed(() => import('./pages/CampaignManagement'), 'CampaignManagement'),
  Helmet: lazyNamed(() => import('./components/Helmet'), 'Helmet'),
  InventoryManagement,
};
